import { MAINADDRESS } from '@/config'

const isMainAddress = (address: string): boolean => {
  const res = MAINADDRESS.some(item => item.toLowerCase() === address.toLowerCase())
  return res
}

export default isMainAddress
